export const PIXELS_PER_METER = 1000;
export const ONE_INCH_IN_METERS = 39.37;
export const ROOM_SIZE_IN_METERS = 7;
